import { Container, Box, Heading } from '@chakra-ui/react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { UpcomingEventCard } from '@/components/ui/shared/event/EventCard/EventCard';
import { FeaturedUpcomingEventCard } from '@/components/ui/shared/event/FeaturedEventCard/FeaturedEventCard';
import { AnyThinEvent } from '@/utils/eventHelpers';
import { getEventHref } from '@/utils/getEventHref';

interface IEventProps {
  event: AnyThinEvent;
}

export const FeaturedEvent: FC<IEventProps> = ({ event }) => {
  const { t } = useTranslation();
  const router = useRouter();

  function handleCardClick(e: React.MouseEvent, thinEvent: AnyThinEvent) {
    const selection = window.getSelection();

    if (selection && selection.toString().length > 0) {
      e.preventDefault(); // don’t navigate if user is selecting text
    } else {
      router.push(getEventHref(thinEvent));
    }
  }

  return (
    <Box bgColor="black">
      <Container>
        <Box w="full" position="relative" bottom="-80px">
          <Heading
            color="white"
            mb={{ base: 6, lg: 10 }}
            lineHeight={{ base: 'taller', lg: '2.75rem' }}
            fontSize={{ base: '2xl', lg: '2rem' }}
            hideBelow="md"
          >
            {t('eventsPage.featuredConferences')}
          </Heading>
          <UpcomingEventCard
            cursor="pointer"
            as="a"
            onClick={(e) => handleCardClick(e, event)}
            event={event}
            hideFrom="md"
          />
          <FeaturedUpcomingEventCard
            cursor="pointer"
            as="a"
            onClick={(e) => handleCardClick(e, event)}
            event={event}
            hideBelow="md"
          />
        </Box>
      </Container>
    </Box>
  );
};
